import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.components.PasswordEditor', {
    hidePasswordButtonTitle: 'Hide password',
    showPasswordButtonTitle: 'Show password',
});
